export const actions = {
  GET_ALL:'getAll',
  GET_ONE:'getOne',
  UPDATE:'update',
  DELETE_ALL:'deleteAll',
  DELETE_ONE:'deleteOne',
  ADD:'add'
}